"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyPagesLayout = void 0;
var _mui = require("@ori-ui/mui");
var _personalMenu = require("@ori/personal-menu");
var _internal = require("../../default/internal");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MyPagesLayout = ({
  children,
  disableWidthLimit = false,
  ...layout
}) => {
  const isDesktop = (0, _mui.useMediaQuery)(({
    breakpoints
  }) => breakpoints.up(_personalMenu.BREAKPOINT_HORIZONTAL_SIDEPANEL));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_internal.DefaultLayout, {
    ...layout,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.ThemeProvider, {
      theme: _mui.theme,
      children: [isDesktop ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_personalMenu.PersonalMenu, {}) : null, disableWidthLimit ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [" ", children, " "]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Inner, {
        children: children
      })]
    })
  });
};
exports.MyPagesLayout = MyPagesLayout;
